import { privateInstance } from "../configs";
import store from "@/store";

export const customerAccountApi = {
  async getCustomers() {
    const res = await privateInstance.get(
      "/ogari/compte-client/api/customer/list/"
    );
    return res.data;
  },
  async retrieveCustomer(id) {
    const res = await privateInstance.get(
      `/ogari/compte-client/api/customer/ru/${id}/`
    );
    return res.data;
  },
  async postCustomer(customer) {
    customer.store = store.getters.getStoreId;
    const res = await privateInstance.post(
      `/ogari/compte-client/api/customer/list/`,
      customer
    );
    return res.data;
  },
  async patchCustomer(id, customer) {
    const res = await privateInstance.patch(
      `/ogari/compte-client/api/customer/ru/${id}/`,
      customer
    );
    return res.data;
  }
};
